import axios from 'axios';

// const baseURL = process.env.VUE_APP_API_URL;
// console.log(`Rodando em modo: ${process.env.NODE_ENV}, API: ${baseURL}`);

const baseURL ="https://api.icaro.fit/api/v1/";
// const baseURL = 'http://localhost:8000/api/v1/';

// const baseURL = 'https://back-icaro-test-erwx.onrender.com/api/v1/'

const api = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: 'application/json',
    Content: 'application/json',
    'content-type': 'application/json',
  },
});

const readStoredToken = () => {
  const directToken = localStorage.getItem('access_token') || localStorage.getItem('token');
  if (directToken) return directToken;

  const rawDados = localStorage.getItem('dados');
  if (!rawDados) return null;

  try {
    const dados = JSON.parse(rawDados);
    if (dados && dados.access_token) return dados.access_token;
    if (dados && dados.token) return dados.token;
    return null;
  } catch (error) {
    return null;
  }
};

api.interceptors.request.use(config => {
  const token = readStoredToken();
  const hasAuthHeader = config.headers && config.headers.Authorization;
  if (token && !hasAuthHeader) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    };
  }
  return config;
});

export default api;
